//save as site: {
// 1day:{}
//1hour:{}
// }
//event driven development
import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { KPI, cachedSetComparisonKpiDataCommunity } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;

function useWhyEffectTriggered(deps: Record<string, unknown>) {
  const prev = useRef<Record<string, unknown> | null>(null);
  useEffect(() => {
    if (prev.current) {
      const changed = Object.keys(deps).filter((k) => prev.current![k] !== deps[k]);
      if (changed.length) {
        console.group('[useEffect] deps changed');
        console.log('changed:', changed);
        console.log(
          'prev:',
          changed.reduce((o, k) => ({ ...o, [k]: prev.current![k] }), {} as any)
        );
        console.log(
          'next:',
          changed.reduce((o, k) => ({ ...o, [k]: deps[k] }), {} as any)
        );
        console.trace('stack');
        console.groupEnd();
      }
    }
    prev.current = deps;
  });
}

export const ComparisonKpiCommunityResolver = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);
  const kpi = useSelector((state: any) => state.kpi);
  const user = useSelector((state: any) => state.user);
  

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;
  // Throttle selectedDate changes to avoid multiple rapid init() calls
  const THROTTLE_MS = 1000;
  const [throttledSelectedDate, setThrottledSelectedDate] = useState(selectedDate);
  const lastEmitRef = useRef<number>(0);
  const trailingTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const now = Date.now();
    const elapsed = now - (lastEmitRef.current || 0);

    if (elapsed >= THROTTLE_MS) {
      lastEmitRef.current = now;
      setThrottledSelectedDate(selectedDate);
    } else {
      if (trailingTimerRef.current) clearTimeout(trailingTimerRef.current);
      trailingTimerRef.current = setTimeout(() => {
        lastEmitRef.current = Date.now();
        setThrottledSelectedDate(selectedDate);
        trailingTimerRef.current = null;
      }, THROTTLE_MS - elapsed);
    }

    return () => {
      if (trailingTimerRef.current) {
        clearTimeout(trailingTimerRef.current);
        trailingTimerRef.current = null;
      }
    };
  }, [selectedDate]);

  
  const pathSegment = location.pathname.split('/')[1];

  async function init() {

    if ( !pathSegment.includes('community')) {
      return;
    }

    if ( kpi?.ComparisonKpiDataCommunityAsyncStatus === 'PENDING' ) {
      return;
    }

    const COMMUNITY_ID = params?.id;
    
    if (!COMMUNITY_ID) {
      return;
    }
    if (metadata?.entities.length === 0) return;


    let siteIds: string[] | null = null;

    if ( user?.tokenContent?.org_role === 'org:admin' || user?.tokenContent?.org_role === 'org:supervisor' ) {
      siteIds = [];
    } else {
      siteIds = metadata?.entities?.site?.filter((site: any) => site?.communityId === COMMUNITY_ID)?.map((site: any) => site?.siteId) || [];

      if (siteIds?.length === 0) {
        return;
      }
    }
    
      

    dispatch(
      KPI.ResetNamedKpiFields(['EnergySite', 'EnergyMember', 'memberRanking'] as any)
    );

    // Token auto-injected by httpService interceptor
    dispatch(
      cachedSetComparisonKpiDataCommunity({
        COMMUNITY_ID,
        selectedDate: throttledSelectedDate,
        selectedTimeSet,
        siteIds,
      }) as any
    );

    
  }

  useWhyEffectTriggered({
    id: params.id,
    selectedDate,
    throttledSelectedDate,
    pathSegment,
    entitiesRef: metadata?.entities,
    entitiesLen: Array.isArray(metadata?.entities) ? metadata.entities.length : 0,
  });

  useEffect(() => {
    init();
  }, [params.id, throttledSelectedDate, pathSegment, metadata?.entities?.length]);

  return <></>;
};
